import { flow, get } from 'lodash/fp';
import { change as changeForm, getFormValues } from 'redux-form';

import { BUY_PRICE } from 'helpers/fieldOptions/ad/priceType';
import {
  PRICE_TYPE_NAME,
  PRICE_RANGE_NAME,
  MONTHLY_PRICE_RANGE_NAME,
} from '../../constants';

export const changePrice = ({ formName }) =>
  function* ({ getState }) {
    const priceType = flow(
      getFormValues(formName),
      get([PRICE_TYPE_NAME]),
    )(getState());

    if (priceType === BUY_PRICE) {
      yield changeForm(formName, MONTHLY_PRICE_RANGE_NAME, null);
    } else {
      yield changeForm(formName, PRICE_RANGE_NAME, null);
    }
  };
